import useFeatureFlagsControllerState from './useFeatureFlagsControllerState'

export default useFeatureFlagsControllerState
